module.exports = __webpack_public_path__ + "static/img/card_icon_pic@2x.66d2b8a4.png";